import { ENTITY_TYPES } from '@sales-center/common'
import { useCheckPermissions } from '@user/store/authorization'

type Props = {
  entityType: ENTITY_TYPES
  isClosedEntity: boolean
  totalServicesCount?: number
}

export function useData(props: Props) {
  const { entityType, totalServicesCount, isClosedEntity } = props

  const notEnoughServicesMessage = `${
    entityType === ENTITY_TYPES.Lead ? 'Lead' : 'Opportunity'
  } must have more than one service/product`

  const [canCreateOpps] = useCheckPermissions(
    'opportunities_convert_/_save_for_later',
  )

  const permissionDenied =
    'You do not have permission to save services for later as new sales opportunities'

  const reopenToSaveServicesForLater = `Re-open this record to save services for later if more than one service is added.`

  const saveForLaterButtonDisabled =
    !canCreateOpps || !totalServicesCount || totalServicesCount <= 1

  const disabledTooltipText = !canCreateOpps
    ? permissionDenied
    : !totalServicesCount || totalServicesCount <= 1
    ? notEnoughServicesMessage
    : isClosedEntity
    ? reopenToSaveServicesForLater
    : ''

  return { disabledTooltipText, saveForLaterButtonDisabled } as const
}
